import { render, staticRenderFns } from "./ApfSchoolBusServiceText.vue?vue&type=template&id=3cec4ad2&scoped=true"
import script from "./ApfSchoolBusServiceText.vue?vue&type=script&lang=js"
export * from "./ApfSchoolBusServiceText.vue?vue&type=script&lang=js"
import style0 from "./ApfSchoolBusServiceText.vue?vue&type=style&index=0&id=3cec4ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec4ad2",
  null
  
)

export default component.exports